<template>
  <v-row
      align="center"
      justify="center"
      >
      <v-col class="text-center mt-8 mb-8" cols="12">
          <h2>Should I {{ question }}?</h2>
          <v-btn dark :href="link" target="_blank">
            Click to find out
          </v-btn>
      </v-col>
      </v-row>
</template>


<script>
// @ is an alias to /src

export default {
  name: 'Question',
  components: {},
  data: () => ({
    "question":"",
    "link":""
  }),
  created() {
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    console.log(params.get("var_name"));
    this.question = params.get("q")
    this.link = params.get("l")
  },
  
}
</script>